import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export const flavorConfigJson = {
    ...require('@/flavor/' + process.env.VUE_APP_FLAVOR + '.json'),
}

Vue.prototype.$flavorConfig = flavorConfigJson

const messages = {}

flavorConfigJson.messages.forEach((lang) => {
    messages[lang] = {...require('@/locales/' + lang + '.json')}
})

console.log("flavorConfigJson.messages", flavorConfigJson.messages)
console.log(messages)

export default new VueI18n({
    locale: window.navigator.language,
    fallbackLocale: flavorConfigJson.fallbackMessages,
    messages,
    silentTranslationWarn: true,
})
